import { render, staticRenderFns } from "./ImageEditors.vue?vue&type=template&id=89c80026"
import script from "./ImageEditors.vue?vue&type=script&lang=js"
export * from "./ImageEditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports